import { useTranslation } from 'react-i18next';
import { SystemErrorScreen } from '@/entities/system/ui';
import SystemTimeoutIcon from '@/shared/assets/system-timeout-icon.svg?react';

export const SystemTimeoutScreen = () => {
  const { t } = useTranslation();

  const translationKey = 'system.health.timeout';

  return (
    <SystemErrorScreen
      title={t(`${translationKey}.title`)}
      description={t(`${translationKey}.description`)}
      icon={SystemTimeoutIcon}
    />
  );
};
